import * as yup from 'yup';

export interface ApiInput {
  first_name: string;
  last_name: string;
  company_name: string;
  service_types: number[];
  company_address: string;
  city: string;
  state: string;
  phone_number: string;
  zip_code: string;
  plain_password: string;
  email: string;
}

export interface FormState {
  city: string;
  companyName: string;
  companyTypeId: number;
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  phone: string;
  state: string;
  companyAddress: string;
  zipcode: string;
  agree: boolean;
}

export const schema = yup.object<FormState>({
  email: yup.string().email('Invalid email').required('required'),
  firstName: yup.string().required('required'),
  lastName: yup.string().required('required'),
  phone: yup
    .string()
    .required('required')
    .matches(/\(\d\d\d\) \d\d\d-\d\d\d\d/, 'invalid format'),
  zipcode: yup.string().required('required'),
  companyName: yup.string().required('required'),
  companyTypeId: yup.number().required('required'),
  state: yup.string().required('required'),
  city: yup.string().required('required'),
  companyAddress: yup.string().required('required'),
  password: yup.string().required('required'),
  agree: yup.boolean().required('required').oneOf([true]),
});

export function format(values: FormState): ApiInput {
  return {
    first_name: values.firstName,
    last_name: values.lastName,
    company_name: values.companyName,
    service_types: [values.companyTypeId],
    company_address: values.companyAddress,
    city: values.city,
    state: values.state,
    phone_number: values.phone,
    zip_code: values.zipcode,
    plain_password: values.password,
    email: values.email,
  };
}
